// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scpPage .ivu-form-item{margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
